export enum ClosedPeriodCause {
  AgreedOff = "AgreedOff",
  InstructorAbsence = "InstructorAbsence",
}
